// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class DangerItemPhoneNumber_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.DangerItemPhoneNumber';
  $t: string = 'SagaSchema.DangerItemPhoneNumber';

  public static GetMembers(): string[] {
    return ['DangerPhoneNumberId', 'DangerId', 'NormalizedNumber', 'ContactCategoryConst'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return DangerItemPhoneNumber_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public DangerPhoneNumberId: Guid = GuidTools.Empty;
  public DangerId: Guid = GuidTools.Empty;
  public NormalizedNumber: string;
  public ContactCategoryConst: number;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.DangerPhoneNumberId;
  }
  get ParentObjId(): any {
    return this.DangerId;
  }
  set ParentObjId(value: any) {
    this.DangerId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
